import { store } from '@betacrew/jars-flux';
import { all, call, put, takeEvery, takeLeading } from 'redux-saga/effects';
import { FIELD_TYPES } from '../../../../libs/formdatavalidator/constants';
import FormEventHandlers from '../../../../libs/utility/formeventhandlers/FormEventHandlers';
import Forms from '../../../../libs/utility/formsutility/Forms';
import General from '../../../../libs/utility/General';
import FormsDataService from '../../../../services/FormsDataService';
import PayerDataService from '../../../../services/PayerDataService';
import RecipientDataService from '../../../../services/RecipientDataService';
import { TOASTER_VARIANT } from '../../../components/toast/constants';
import { PAGE_STATE } from '../../constants/constants';
import { addNotifications } from '../../toaster/ToasterPortalSlice';
import { CURRENT_FORM_CREATION_MODULE } from '../constants';
import { setFinalSaveSingleFormData, setSaveSingleFormSuccessData } from '../FormsSectionSlice';
import { CREATE_FORMS_LOADING_STATES, FORMDATA_KEYS, FORM_STEP, FORM_VIEWS } from './constants';
import { componentKey, setElementToBeFocused, setFormDataFromRecordId, setFormFieldsList, setFormsInSeriesHistory, setFormsList, setFormsPreLoadedData, setGuidedFormList, setInitialInteractionPopupWObj, setIsIncorrectFormRecordId, setIsIRSViewAvailable, setIsStepperViewAvailable, setIsYearFormTypeSelected, setLoadingState, setNxtFormInSeriesDetails, setOnDependentFields, setPayerList, setPrevFormInSeriesDetails, setRecipientList, setShouldLoadNextFormInSeries, setTempFormFieldsList, setToCreateFormData, setUserInteractionPopupWResponseObj, updateFormsPreLoadedData, updateUserInteractionPopupWResponseObj, setStateNamesList, setStatePayrollFormsList, setSelectedStateName, setRecipientListLoadingState } from './CreateFormSlice';
import StatePayrollDataService from '../../../../services/StatePayrollFormsDataService';

export const { getFormsList, getPayerList, getPayer, getPayerOrRecipientForIRSView, getFormFields, getRecipientList, getRecipient, onDependentFieldChangeGetValues, getFormData, saveForm, getStateNamesList, getStatePayrollFormsList } = {

    getFormsList: (payload) => {
        return {
            type: "CREATE_FORM/GET_FORMS_LIST",
            payload: payload
        }
    },
    getPayerList: (payload) => {
        return {
            type: "CREATE_FORM/GET_PAYER_LIST",
            payload: payload
        }
    },
    getPayer: (payload) => {
        return {
            type: "CREATE_FORM/GET_PAYER_BY_ID",
            payload: payload
        }
    },
    getPayerOrRecipientForIRSView: (payload) => {
        return {
            type: "CREATE_FORM/GET_PAYER_BY_ID_FOR_IRSVIEW",
            payload: payload
        }
    },
    getRecipientList: (payload) => {
        return {
            type: "CREATE_FORM/GET_RECIPIENT_LIST",
            payload: payload
        }
    },
    getRecipient: (payload) => {
        return {
            type: "CREATE_FORM/GET_RECIPIENT_BY_ID",
            payload: payload
        }
    },
    getFormFields: (payload) => {
        return {
            type: "CREATE_FORM/GET_FORM_BOXES",
            payload: payload
        }
    },
    onDependentFieldChangeGetValues: (payload) => {
        return {
            type: "CREATE_FORM/DEPENDENT_FIELD_CHANGE_NOTIFY",
            payload: payload
        }
    },
    getFormData: (payload) => {
        return {
            type: "CREATE_FORM/GET_FORM_DATA",
            payload: payload
        }
    },
    saveForm: (payload) => {
        return {
            type: "CREATE_FORM/SAVE_FORM",
            payload: payload
        }
    },

    getStateNamesList: (payload) => {
        return {
            type: "CREATE_FORM/GET_STATE_NAMES_LIST",
            payload: payload
        }
    },
    getStatePayrollFormsList: (payload) => {
        return {
            type: "CREATE_STATE_PAYROLL_FORM/GET_STATE_PAYROLL_FORMS",
            payload
        }
    },

}

function* getPayerListAsync(action) {
    try {
        const { formName, year } = action.payload

        yield put(setLoadingState({ state: CREATE_FORMS_LOADING_STATES.GET_FORM_CONFIGURATIONS_PAGE_LOADING }));
        const response = yield PayerDataService.getPayersList({ formName, year });
        if (response) {
            if (response.data.Status === 0) {
                yield put(addNotifications({
                    heading: "Error",
                    message: response?.data?.Message,
                    variant: TOASTER_VARIANT.DANGER
                }));
            } else {
                const payerList = (response?.data?.Data ?? []).filter(obj => obj?.IsActive === true);
                yield put(setPayerList({ data: payerList }));
                const newPayerListWithExtensibleObjects = JSON.parse(JSON.stringify(payerList));
                General.addOptionAndValueKeys(newPayerListWithExtensibleObjects, "LastName", "PayerDetailId");
                yield put(updateFormsPreLoadedData({ payerList: newPayerListWithExtensibleObjects }));
            }
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: CREATE_FORMS_LOADING_STATES.GET_FORM_CONFIGURATIONS_PAGE_READY }))
    }
}

function* getPayerAsync(action) {
    try {
        yield put(setLoadingState({ state: CREATE_FORMS_LOADING_STATES.PAYER_PAGE_LOADING }));
        const response = yield PayerDataService.getPayer(action.payload);
        if (response) {
            if (response?.data?.Status === 0) {
                yield put(addNotifications({
                    heading: "Error",
                    message: response?.data?.Message,
                    variant: TOASTER_VARIANT.DANGER
                }));
            } else {
                const payer = response?.data?.Data ?? null;
                yield put(setToCreateFormData({ selectedPayer: payer }));
            }
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: CREATE_FORMS_LOADING_STATES.PAYER_PAGE_READY }))
    }
}

function* getPayerOrRecipientForIRSViewAsync(action) {
    try {
        const { tempFormFieldsList, toCreateFormData, payerOrRecipientId, callForEndpoint, field } = action.payload;

        yield put(setLoadingState({ state: CREATE_FORMS_LOADING_STATES.GET_FORM_CONFIGURATIONS_PAGE_LOADING }));
        let response;
        let newTempFormFieldsList;
        let updatedToCreateFormData;

        if (callForEndpoint === "PAYER") {
            response = yield PayerDataService.getPayer(payerOrRecipientId);
        } else {
            response = yield RecipientDataService.getRecipient(payerOrRecipientId);
        }
        if (response) {
            if (response.data.Status === 0) {
                yield put(addNotifications({
                    heading: "Error",
                    message: response?.data?.Message,
                    variant: TOASTER_VARIANT.DANGER
                }));
            } else {
                if (callForEndpoint === "PAYER") {
                    const payerData = response?.data?.Data ?? null;
                    yield put(setToCreateFormData({ selectedPayer: payerData }));
                    updatedToCreateFormData = {
                        ...toCreateFormData,
                        selectedPayer: payerData,
                    }
                    newTempFormFieldsList = FormEventHandlers.updateTempFormFieldsListOnPayerSelect(tempFormFieldsList, updatedToCreateFormData, () => { }, false);
                } else {
                    const recipientData = response?.data?.Data ?? null;
                    yield put(setToCreateFormData({ selectedRecipient: recipientData }));
                    updatedToCreateFormData = {
                        ...toCreateFormData,
                        selectedRecipient: recipientData,
                    }
                    newTempFormFieldsList = FormEventHandlers.handleRecipientSelect(tempFormFieldsList, updatedToCreateFormData, () => { }, () => { }, false, false);
                }
                yield call(onDependentFieldChangeGetValuesAsync, {
                    payload: {
                        formId: updatedToCreateFormData.selectedForm.FormId,
                        year: updatedToCreateFormData.selectedYear,
                        fieldId: field?.Name,
                        allFields: newTempFormFieldsList,
                    }
                });
            }
        }
    } catch (error) {
        console.log(error)
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: CREATE_FORMS_LOADING_STATES.GET_FORM_CONFIGURATIONS_PAGE_READY }))
    }
}

function* getRecipientListAsync(action) {

    const { LoadableLoadingState } = action.payload;
    try {
        yield put(setRecipientListLoadingState({ state: LoadableLoadingState.loading }));
        const response = yield RecipientDataService.getRecipientList(action.payload);
        if (response) {
            if (response?.data?.Status === 0) {
                yield put(addNotifications({
                    heading: "Error",
                    message: response?.data?.Message,
                    variant: TOASTER_VARIANT.DANGER
                }));
            } else {
                const recipientList = response?.data?.Data ?? "";
                yield put(setRecipientList({ data: recipientList }));
                const newRecipientListWithExtensibleObjects = JSON.parse(JSON.stringify(recipientList));
                General.addOptionAndValueKeys(newRecipientListWithExtensibleObjects, "Name", "RecipentDetailId");
                yield put(updateFormsPreLoadedData({ recipientList: newRecipientListWithExtensibleObjects }));
            }
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setRecipientListLoadingState({ state: LoadableLoadingState.ready }))
    }
}

function* getRecipientAsync(action) {
    try {
        yield put(setLoadingState({ state: CREATE_FORMS_LOADING_STATES.RECIPIENT_PAGE_LOADING }));
        const response = yield RecipientDataService.getRecipient(action.payload);
        if (response) {
            if (response?.data?.Status === 0) {
                yield put(addNotifications({
                    heading: "Error",
                    message: response?.data?.Message,
                    variant: TOASTER_VARIANT.DANGER
                }));
            } else {
                const recipient = response?.data?.Data ?? null;
                yield put(setToCreateFormData({ selectedRecipient: recipient }));
            }
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: CREATE_FORMS_LOADING_STATES.RECIPIENT_PAGE_READY }))
    }
}

function* getFormsListAsync(action) {
    try {
        yield put(setLoadingState({ state: CREATE_FORMS_LOADING_STATES.SELECT_YEAR_LOADING }));
        const response = yield FormsDataService.getFormsList();
        if (response) {
            if (response?.data?.Status === 0) {
                yield put(addNotifications({
                    heading: "Error",
                    message: response?.data?.Message,
                    variant: TOASTER_VARIANT.DANGER
                }));
            } else if (response?.data?.Status == 1) {
                const formsList = response.data.Data;

                yield put(setFormsList({
                    ...formsList,
                    Forms: formsList.Forms.filter(record => record.AvailableFor.split(',').includes(CURRENT_FORM_CREATION_MODULE.SINGLE)),
                }));

                if (formsList?.Years) {
                    const latestYear = Math.max(...formsList?.Years)
                    if (latestYear) {
                        yield put(setToCreateFormData({ selectedYear: latestYear }));
                    }
                }
            }
        }
    } catch (error) {
        console.log(error)
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: CREATE_FORMS_LOADING_STATES.SELECT_YEAR_READY }))
    }
}

function* getFormFieldsAsync(action) {
    try {
        const { formName, formYear, toCreateFormData, formsPreLoadedData, returnedFormRecordIdData } = action.payload;
        yield put(setLoadingState({ state: CREATE_FORMS_LOADING_STATES.GET_FORM_CONFIGURATIONS_PAGE_LOADING, message: "Fetching form fields..." }));
        const response = yield FormsDataService.getFormFields(formName, formYear, toCreateFormData?.FormRecordId);

        if (response) {
            if (response?.data?.Status === 0) {
                yield put(addNotifications({
                    heading: "Error",
                    message: response?.data?.Message,
                    variant: TOASTER_VARIANT.DANGER
                }));
            } else {
                const sortedFormsFieldsList = yield Forms.formStepFieldSorting(response.data.Data);
                let updatedFormsPreLoadedData = { ...formsPreLoadedData };

                const groupedFederalFields = []

                const updateFieldsList = sortedFormsFieldsList.map((item) => {

                    const prepopulateField = formsPreLoadedData.hasOwnProperty(item?.FrontEndSource) ? formsPreLoadedData[item?.FrontEndSource] : null;
                    if (toCreateFormData?.isFormEditMode && returnedFormRecordIdData.hasOwnProperty(item?.Name)) {
                        let tempUpdatedFieldObj = {
                            ...item,
                            inputValue: returnedFormRecordIdData[item?.Name],
                            isVisible: ((returnedFormRecordIdData[item?.Name] && returnedFormRecordIdData[item?.Name] !== "false") ? true : item?.isVisible),
                        };
                        if (item?.Type === FIELD_TYPES.MULTISELECTENUM && prepopulateField) {
                            let multiSelectEnumOptions = prepopulateField;
                            var inputValueArray = (returnedFormRecordIdData[item?.Name]).split(',');
                            if (inputValueArray.length > 0 && inputValueArray[0] !== "") {
                                var updatedMultiSelectEnumOptions = multiSelectEnumOptions.map(function (option) {
                                    if (inputValueArray.includes(option?.value)) {
                                        return { ...option, checked: true };
                                    }
                                    return option;
                                });

                                updatedFormsPreLoadedData = {
                                    ...updatedFormsPreLoadedData,
                                    [item?.FrontEndSource]: [...updatedMultiSelectEnumOptions],
                                }
                            }
                        }
                        if (item?.Category === FORM_STEP.FEDERAL) {
                            tempUpdatedFieldObj = {
                                ...tempUpdatedFieldObj,
                                isSelected: ((returnedFormRecordIdData[item?.Name] && returnedFormRecordIdData[item?.Name] !== "false") ? true : false),
                            }
                        }
                        if (tempUpdatedFieldObj?.GroupId) {
                            Forms.groupFormFields(groupedFederalFields, tempUpdatedFieldObj)
                        }
                        return tempUpdatedFieldObj;
                    } else if (item.Name === "YearId") {
                        return {
                            ...item,
                            inputValue: toCreateFormData?.selectedYear ?? null,
                        }
                    } else if (item.Name === "FormName") {
                        return {
                            ...item,
                            inputValue: toCreateFormData?.selectedForm?.FormId ?? null,
                        }
                    }
                    else if (!Array.isArray(prepopulateField) && typeof prepopulateField !== "object" && prepopulateField !== null) {
                        return {
                            ...item,
                            inputValue: prepopulateField,
                        };
                    }
                    return item;
                });

                const updateFieldsListWtUpdatedIsSelectd = updateFieldsList.map((item) => {
                    if (item?.Category === FORM_STEP.FEDERAL) {
                        if (item?.GroupId) {
                            const [currentGroupedFieldsArr] = groupedFederalFields.filter(field => field[0].GroupId === item.GroupId) || []
                            return {
                                ...item,
                                isSelected: currentGroupedFieldsArr?.find(field => field?.isSelected) ? true : false,
                            }
                        } else {
                            return item
                        }
                    } else {
                        return item
                    }
                })

                yield put(setFormFieldsList({ data: updateFieldsListWtUpdatedIsSelectd }));
                yield put(updateFormsPreLoadedData({
                    ...updatedFormsPreLoadedData
                }));
            }
        }
    } catch (error) {
        console.log(error)
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: CREATE_FORMS_LOADING_STATES.GET_FORM_CONFIGURATIONS_PAGE_READY }))
    }
}

function* onDependentFieldChangeGetValuesAsync(action) {
    try {
        const { formId, year, fieldId, allFields, targetElement } = action.payload;
        yield put(setLoadingState({ state: CREATE_FORMS_LOADING_STATES.DEPENDENT_FIELD_CHANGE_LOADING }));
        const response = yield FormsDataService.onDependentFieldChangeGetValues({ formId, year, fieldId, allFields });
        if (response) {
            if (response?.data?.Status === 0) {
                yield put(addNotifications({
                    heading: "Error",
                    message: response?.data?.Message,
                    variant: TOASTER_VARIANT.DANGER
                }));
            } else {
                if (response?.data?.Data?.interaction) {
                    yield put(updateUserInteractionPopupWResponseObj({
                        ...response.data.Data.interaction
                    }));
                }
                const responseDataArray = response?.data?.Data?.allFields ?? [];
                yield put(setTempFormFieldsList(responseDataArray));
                if (response?.data?.Data?.PreLoadedData) {
                    yield put(updateFormsPreLoadedData({
                        ...response?.data?.Data?.PreLoadedData,
                    }));
                }
            }
        }
        if (targetElement) {
            yield put(setElementToBeFocused(targetElement))
        } else {
            yield put(setElementToBeFocused(fieldId))
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: CREATE_FORMS_LOADING_STATES.DEPENDENT_FIELD_CHANGE_READY }))
    }
}

function* getFormDataAsync(action) {
    try {
        const { formName, formYear, toCreateFormData, formsPreLoadedData, getFormFieldsFlag, page } = action.payload;
        let tempToCreateFormData = toCreateFormData;
        yield put(setLoadingState({ state: CREATE_FORMS_LOADING_STATES.GET_FORM_CONFIGURATIONS_PAGE_LOADING }));
        let recordIdResponse;
        let formDataResponse;
        const recordIdToBeSentGetFormData = (toCreateFormData?.FormRecordId) ?? 0;
        if (tempToCreateFormData?.isFormEditMode) {
            if (formName.includes("Payroll")) {
                recordIdResponse = yield call(FormsDataService.getStatePayrollFromRecordId, formName, recordIdToBeSentGetFormData, page);
            }
            else {
                recordIdResponse = yield call(FormsDataService.getFormFromRecordId, formName, recordIdToBeSentGetFormData, page);
            }
            formDataResponse = yield call(FormsDataService.getFormData, formName, formYear, recordIdToBeSentGetFormData);
        } else {
            formDataResponse = yield FormsDataService.getFormData(formName, formYear, recordIdToBeSentGetFormData);
        }
        let returnedFormRecordIdData = null;
        let stopHere = false;
        if (tempToCreateFormData?.isFormEditMode) {
            if (recordIdResponse) {
                if (recordIdResponse?.data?.Status === 1) {
                    returnedFormRecordIdData = recordIdResponse?.data?.Data;
                    yield put(setFormDataFromRecordId(returnedFormRecordIdData));
                } else {
                    yield put(addNotifications({
                        heading: "Error",
                        message: recordIdResponse?.data?.Message,
                        variant: TOASTER_VARIANT.DANGER
                    }));
                    yield put(setIsIncorrectFormRecordId(true));
                    tempToCreateFormData = {
                        ...tempToCreateFormData,
                        isFormEditMode: null,
                    }
                    yield put(setToCreateFormData({ ...tempToCreateFormData }));
                    yield put(setIsYearFormTypeSelected(false));
                    stopHere = true;
                }
            }
        }
        if (!stopHere) {
            if (formDataResponse) {
                if (formDataResponse?.data?.Status === 0) {
                    yield put(addNotifications({
                        heading: "Error",
                        message: formDataResponse?.data?.Message,
                        variant: TOASTER_VARIANT.DANGER
                    }));
                } else {
                    let tempFormsPreLoadedData = {};
                    const returnedFormData = formDataResponse?.data?.Data ?? {};

                    for (const key in returnedFormData) {
                        if (key === 'interaction') {
                            yield put(setInitialInteractionPopupWObj(returnedFormData[key]));
                            continue;
                        }
                        if (returnedFormData[key]) {
                            tempFormsPreLoadedData[key] = returnedFormData[key];
                        }
                        if (key === FORM_VIEWS.SUPPORTEDVIEWS) {
                            (!returnedFormData[key].includes(FORM_VIEWS.STEPPERVIEW)) ? yield put(setIsStepperViewAvailable(false)) : null;
                            (!returnedFormData[key].includes(FORM_VIEWS.IRSVIEW)) ? yield put(setIsIRSViewAvailable(false)) : null;
                        }
                    }
                    yield put(updateFormsPreLoadedData({
                        ...formsPreLoadedData,
                        ...tempFormsPreLoadedData
                    }));

                    if (getFormFieldsFlag) {
                        yield call(getFormFieldsAsync, {
                            payload: {
                                formName: formName, formYear: formYear, toCreateFormData: tempToCreateFormData, formsPreLoadedData: {
                                    ...formsPreLoadedData,
                                    ...tempFormsPreLoadedData,
                                },
                                returnedFormRecordIdData: returnedFormRecordIdData,
                            }
                        });
                    }
                }
            }
        }
    } catch (error) {
        console.log(error)
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: CREATE_FORMS_LOADING_STATES.GET_FORM_CONFIGURATIONS_PAGE_READY }))
    }
}

function* saveFormAsync(action) {
    try {
        const { formName, formData, toCreateFormData, formsInSeriesHistory } = action.payload;
        yield put(setLoadingState({ state: CREATE_FORMS_LOADING_STATES.SAVING_FORM_LOADING }));
        yield put(setFinalSaveSingleFormData({ ...formData }));
        let response;
        if (formName.includes("Payroll")) {
            response = yield FormsDataService.statePayrollSaveForm(formName, formData);
        }
        else {
            response = yield FormsDataService.saveForm(formName, formData);
        }

        if (response) {
            if (response?.data?.Status === 0) {                
                let additionalErrorMessage = "";
                if (response?.data?.Data) {
                    const resultData = response?.data?.Data;
                    for (const key in resultData) {
                        if (resultData.hasOwnProperty(key)) {
                            const messages = resultData[key].join('<br/>');
                            additionalErrorMessage += `${messages}<br/>`;
                        }
                    }
                } else {
                    additionalErrorMessage = response?.data?.Message;
                }
                yield put(addNotifications({
                    heading: "Error",
                    message: additionalErrorMessage,
                    variant: TOASTER_VARIANT.DANGER
                }));
            } else {                
                if (response?.data?.Data?.Action) {                    
                    let nxtForm = response?.data?.Data?.Action;
                    yield put(setToCreateFormData({
                        selectedForm: {
                            ...toCreateFormData?.selectedForm,
                            FormId: nxtForm,
                        },
                        isFormEditMode: true,
                        FormRecordId: response?.data?.Data?.FormRecordId,
                    }));
                    yield put(setNxtFormInSeriesDetails(nxtForm));
                    yield put(setPrevFormInSeriesDetails(formName));
                    if (!formsInSeriesHistory.includes(formName)) {
                        let tempFormsInSeriesHistory = [...formsInSeriesHistory];
                        tempFormsInSeriesHistory.push(formName);
                        yield put(setFormsInSeriesHistory(tempFormsInSeriesHistory))
                    }
                    yield put(setShouldLoadNextFormInSeries(true));
                    yield put(setOnDependentFields({}));
                    //yield put(setFormsPreLoadedData({}));
                } else {                    
                    yield put(setSaveSingleFormSuccessData(response.data.Data));
                }
            }
        }
    } catch (error) {
        console.log(error)
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
        }));
    } finally {
        yield put(setLoadingState({ state: CREATE_FORMS_LOADING_STATES.SAVING_FORM_READY }))
    }
}

function* getStateNamesListAsync(action) {
    yield put(setLoadingState({ state: CREATE_FORMS_LOADING_STATES.SELECT_STATES_LOADING }));

    const { stateNameFromUrl = null} = action.payload; 
    const response = yield StatePayrollDataService.getStateNamesList();
    try {
        if (response?.data?.Status == 1) {
            let statesList = response?.data?.Data ?? {}
            if(statesList?.StateNames[0]){
                const stateNamesArray = statesList.StateNames[0].split(',').map(state => state.trim());
                statesList = {
                    ...statesList,
                    StateNames: stateNamesArray,
                }
            }
            yield put(setStateNamesList(statesList));
            if(stateNameFromUrl){
                if(statesList?.StateNames){
                    const selectedStateRow = statesList.StateNames.find(state => state === stateNameFromUrl)
                    if(selectedStateRow){
                        yield put(setSelectedStateName({label: selectedStateRow, value: selectedStateRow}))
                    }
                }
            }
        }
        else {
            yield put(addNotifications({
                heading: "Error",
                message: response?.data?.Message
            }));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error,
        }));
        console.error();
    }
    finally {
        yield put(setLoadingState({ state: CREATE_FORMS_LOADING_STATES.SELECT_STATES_READY }))
    }
}

function* getStatePayrollFormsListAsync(action) {
    try {
        yield put(setLoadingState({ state: CREATE_FORMS_LOADING_STATES.SELECT_STATE_PAYROLL_FORMS_LOADING }));
        const response = yield StatePayrollDataService.getStatePayrollFormsList(action.payload);
        const { Message, Status, Data } = response?.data;

        if (Status == 1) {
            yield put(setStatePayrollFormsList(Data ?? []));
        }
        else {
            yield put(addNotifications({
                heading: "Error",
                message: Message
            }));
        }
    }
    catch (error) {
        console.log(error);
        yield put(addNotifications({
            heading: "Error",
            message: error,
        }));
    } finally {
        yield put(setLoadingState({ state: CREATE_FORMS_LOADING_STATES.SELECT_STATE_PAYROLL_FORMS_READY }))
    }
}


function* rootSaga() {
    yield all([
        takeLeading(getFormsList().type, getFormsListAsync),
        takeLeading(getPayerList().type, getPayerListAsync),
        takeLeading(getPayer().type, getPayerAsync),
        takeLeading(getPayerOrRecipientForIRSView().type, getPayerOrRecipientForIRSViewAsync),
        takeLeading(getRecipientList().type, getRecipientListAsync),
        takeLeading(getRecipient().type, getRecipientAsync),
        takeLeading(getFormFields().type, getFormFieldsAsync),
        takeLeading(getFormData().type, getFormDataAsync),
        takeEvery(onDependentFieldChangeGetValues().type, onDependentFieldChangeGetValuesAsync),
        takeLeading(saveForm().type, saveFormAsync),
        takeLeading(getStateNamesList().type, getStateNamesListAsync),
        takeLeading(getStatePayrollFormsList().type, getStatePayrollFormsListAsync),
    ]);
}
store.sagaManager.addSaga(componentKey, rootSaga);